import U, { memo as V, useMemo as de, useState as I, useEffect as G, useCallback as Y, useContext as ie, createContext as Ge } from "react";
import { StudyParticipantRole as D, InvitationStatus as y, TypesOfContainer as L } from "@prometheus/enums";
import { ID_COLUMN as Oe, CREATED_COLUMN as ke, UPDATED_COLUMN as qe, AUTHOR_COLUMN as Ke, MessageIcon as Je, IconButton as Ce, FormElementContainer as ae, ShortListWrapper as He, FormElement as $, FormActionsContainer as Xe, DateCell as Ze, PageList as Qe, SpinnerWidgetContainer as et } from "@prometheus/features";
import { api as N, getSortDirection as tt, chain as Le, groupBy as rt, capitalize as ue, startCase as $e, getFullNameUser as oe, createSortingMethodListConfig as st, createFiltersPanelListConfig as nt, createCrudMethodsListConfig as at } from "@prometheus/utils";
import { useTheme as it, Tooltip as Q, Box as le, transparentize as ye, Grid as c, Spinner as Me, Icon as w, ContentBlock as ot, Select as lt, Autocomplete as ee, Textarea as ct, Button as O, useNotifications as dt, Block as ut, Input as mt, Divider as pt, Avatar as xt } from "@prometheus/components";
import B from "@emotion/styled";
import { useList as me, ModalContext as Ue, useEntityNew as ht } from "@prometheus/hooks";
import { Status as gt } from "@prometheus/types";
import { getSummary as Se, setBreadcrumbs as ft } from "@prometheus/redux";
import { useDispatch as De, useSelector as Be } from "react-redux";
import { useParams as jt, Routes as bt, Route as Te } from "react-router-dom";
var ce = { exports: {} }, X = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ve;
function Et() {
  if (ve) return X;
  ve = 1;
  var e = Symbol.for("react.transitional.element"), r = Symbol.for("react.fragment");
  function n(i, d, l) {
    var p = null;
    if (l !== void 0 && (p = "" + l), d.key !== void 0 && (p = "" + d.key), "key" in d) {
      l = {};
      for (var m in d)
        m !== "key" && (l[m] = d[m]);
    } else l = d;
    return d = l.ref, {
      $$typeof: e,
      type: i,
      key: p,
      ref: d !== void 0 ? d : null,
      props: l
    };
  }
  return X.Fragment = r, X.jsx = n, X.jsxs = n, X;
}
var Z = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Re;
function Ct() {
  return Re || (Re = 1, process.env.NODE_ENV !== "production" && function() {
    function e(s) {
      if (s == null) return null;
      if (typeof s == "function")
        return s.$$typeof === xe ? null : s.displayName || s.name || null;
      if (typeof s == "string") return s;
      switch (s) {
        case S:
          return "Fragment";
        case P:
          return "Profiler";
        case _:
          return "StrictMode";
        case J:
          return "Suspense";
        case F:
          return "SuspenseList";
        case C:
          return "Activity";
      }
      if (typeof s == "object")
        switch (typeof s.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), s.$$typeof) {
          case h:
            return "Portal";
          case M:
            return (s.displayName || "Context") + ".Provider";
          case q:
            return (s._context.displayName || "Context") + ".Consumer";
          case K:
            var g = s.render;
            return s = s.displayName, s || (s = g.displayName || g.name || "", s = s !== "" ? "ForwardRef(" + s + ")" : "ForwardRef"), s;
          case T:
            return g = s.displayName || null, g !== null ? g : e(s.type) || "Memo";
          case b:
            g = s._payload, s = s._init;
            try {
              return e(s(g));
            } catch {
            }
        }
      return null;
    }
    function r(s) {
      return "" + s;
    }
    function n(s) {
      try {
        r(s);
        var g = !1;
      } catch {
        g = !0;
      }
      if (g) {
        g = console;
        var E = g.error, v = typeof Symbol == "function" && Symbol.toStringTag && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return E.call(
          g,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          v
        ), r(s);
      }
    }
    function i(s) {
      if (s === S) return "<>";
      if (typeof s == "object" && s !== null && s.$$typeof === b)
        return "<...>";
      try {
        var g = e(s);
        return g ? "<" + g + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function d() {
      var s = H.A;
      return s === null ? null : s.getOwner();
    }
    function l() {
      return Error("react-stack-top-frame");
    }
    function p(s) {
      if (he.call(s, "key")) {
        var g = Object.getOwnPropertyDescriptor(s, "key").get;
        if (g && g.isReactWarning) return !1;
      }
      return s.key !== void 0;
    }
    function m(s, g) {
      function E() {
        ge || (ge = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          g
        ));
      }
      E.isReactWarning = !0, Object.defineProperty(s, "key", {
        get: E,
        configurable: !0
      });
    }
    function j() {
      var s = e(this.type);
      return fe[s] || (fe[s] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), s = this.props.ref, s !== void 0 ? s : null;
    }
    function f(s, g, E, v, k, A, re, se) {
      return E = A.ref, s = {
        $$typeof: o,
        type: s,
        key: g,
        props: A,
        _owner: k
      }, (E !== void 0 ? E : null) !== null ? Object.defineProperty(s, "ref", {
        enumerable: !1,
        get: j
      }) : Object.defineProperty(s, "ref", { enumerable: !1, value: null }), s._store = {}, Object.defineProperty(s._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(s, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(s, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: re
      }), Object.defineProperty(s, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: se
      }), Object.freeze && (Object.freeze(s.props), Object.freeze(s)), s;
    }
    function x(s, g, E, v, k, A, re, se) {
      var R = g.children;
      if (R !== void 0)
        if (v)
          if (We(R)) {
            for (v = 0; v < R.length; v++)
              u(R[v]);
            Object.freeze && Object.freeze(R);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else u(R);
      if (he.call(g, "key")) {
        R = e(s);
        var z = Object.keys(g).filter(function(Ve) {
          return Ve !== "key";
        });
        v = 0 < z.length ? "{key: someKey, " + z.join(": ..., ") + ": ...}" : "{key: someKey}", Ee[R + v] || (z = 0 < z.length ? "{" + z.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          v,
          R,
          z,
          R
        ), Ee[R + v] = !0);
      }
      if (R = null, E !== void 0 && (n(E), R = "" + E), p(g) && (n(g.key), R = "" + g.key), "key" in g) {
        E = {};
        for (var ne in g)
          ne !== "key" && (E[ne] = g[ne]);
      } else E = g;
      return R && m(
        E,
        typeof s == "function" ? s.displayName || s.name || "Unknown" : s
      ), f(
        s,
        R,
        A,
        k,
        d(),
        E,
        re,
        se
      );
    }
    function u(s) {
      typeof s == "object" && s !== null && s.$$typeof === o && s._store && (s._store.validated = 1);
    }
    var a = U, o = Symbol.for("react.transitional.element"), h = Symbol.for("react.portal"), S = Symbol.for("react.fragment"), _ = Symbol.for("react.strict_mode"), P = Symbol.for("react.profiler"), q = Symbol.for("react.consumer"), M = Symbol.for("react.context"), K = Symbol.for("react.forward_ref"), J = Symbol.for("react.suspense"), F = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), C = Symbol.for("react.activity"), xe = Symbol.for("react.client.reference"), H = a.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, he = Object.prototype.hasOwnProperty, We = Array.isArray, te = console.createTask ? console.createTask : function() {
      return null;
    };
    a = {
      react_stack_bottom_frame: function(s) {
        return s();
      }
    };
    var ge, fe = {}, je = a.react_stack_bottom_frame.bind(
      a,
      l
    )(), be = te(i(l)), Ee = {};
    Z.Fragment = S, Z.jsx = function(s, g, E, v, k) {
      var A = 1e4 > H.recentlyCreatedOwnerStacks++;
      return x(
        s,
        g,
        E,
        !1,
        v,
        k,
        A ? Error("react-stack-top-frame") : je,
        A ? te(i(s)) : be
      );
    }, Z.jsxs = function(s, g, E, v, k) {
      var A = 1e4 > H.recentlyCreatedOwnerStacks++;
      return x(
        s,
        g,
        E,
        !0,
        v,
        k,
        A ? Error("react-stack-top-frame") : je,
        A ? te(i(s)) : be
      );
    };
  }()), Z;
}
process.env.NODE_ENV === "production" ? ce.exports = Et() : ce.exports = Ct();
var t = ce.exports;
const yt = (e) => {
  const { pageNumber: r, pageSize: n, sortBy: i, query: d } = e, l = tt(i), p = `/users/list?${d || ""}&size=${n || ""}&page=${r || ""}&sort=${l}`;
  return N.get(p);
}, St = () => N.get("/users/tenant/users"), Tt = (e) => N.get(`/users/${e}`), vt = (e) => {
  const r = `/users/filter?${e}`;
  return N.get(r);
}, Rt = (e) => N.get(`/studies/${e}/invites-legacy`), It = (e) => (r) => N.get(`/studies/${e}/participants/${r}`), Fe = (e) => (r) => N.post(`/studies/${e}/invites`, r), Nt = (e) => N.post(`/studies/participants/${e}/enable`), Pt = (e) => N.post(`/studies/participants/${e}/disable`), wt = (e) => N.post(`/studies/invites/${e}/dismiss`, { note: "" }), At = (e) => (r) => Promise.resolve({}), _t = (e) => N.get(`/studies/${e}/candidates`), Ot = (e) => N.get(`/users/tenant/${e}`), kt = () => N.get("/users/sorts");
var W = /* @__PURE__ */ ((e) => (e.BY_NAME = "BY_NAME", e.BY_STATUS = "BY_STATUS", e))(W || {});
const Ie = (e) => {
  const r = /* @__PURE__ */ new Map([
    [D.LEAD_INVESTIGATOR, "0"],
    [D.CONTRIBUTOR, "1"]
  ]);
  return r.get(e) || String(r.size);
}, Ne = (e) => {
  const r = /* @__PURE__ */ new Map([
    [y.ACTIVE, "0"],
    [y.ACCEPTED, "0"],
    [y.PENDING, "1"],
    [y.DISABLED, "2"],
    [y.CANCELLED, "3"],
    [y.REJECTED, "3"]
  ]);
  return r.get(e) || String(r.size);
};
function Lt(e) {
  return e.sort(
    (r, n) => String(r.subject.firstName + r.subject.lastName).localeCompare(
      n.subject.firstName + n.subject.lastName
    )
  ).sort((r, n) => {
    let i = Ie(r.role.id) + Ne(r.status), d = Ie(n.role.id) + Ne(n.status);
    return i.localeCompare(d);
  }), Le(e).groupBy((r) => {
    var n;
    return (n = r.subject) == null ? void 0 : n.id;
  }).map((r, n) => {
    const i = r[0].subject, d = r[0].actions;
    return {
      ...i,
      actions: d,
      id: n,
      fullName: `${(i == null ? void 0 : i.firstName) || ""} ${(i == null ? void 0 : i.middleName) || ""} ${(i == null ? void 0 : i.lastName) || ""}`,
      invitations: r,
      groupedByRole: rt(r, (l) => `${l.role.id}--${l.status}`)
    };
  }).value();
}
function ze(e) {
  return Object.values(Lt(e));
}
function $t(e) {
  return ze(e);
}
function Mt(e) {
  return Le(e).groupBy((n) => n.status).map((n, i) => ({
    id: i,
    participants: ze(n)
  })).value();
}
function Pe(e) {
  return e === W.BY_NAME ? $t : Mt;
}
const Ut = {
  name: "participants",
  title: "Participants",
  modal: {
    header: {
      new: "New participant"
    }
  },
  addButtonText: "Add participant",
  getApiMethods: (e, r) => ({
    primaryKey: "id",
    methods: {
      read: {
        method: () => {
          switch (e) {
            case L.WORKSPACE:
              return Promise.resolve({});
            case L.STUDY:
              return Rt(r);
          }
        },
        formatter: Pe(
          W.BY_NAME
        )
      },
      get: {
        method: (n) => {
          switch (e) {
            case L.WORKSPACE:
              return Promise.resolve({});
            case L.STUDY:
              return It(r)(n);
          }
        },
        formatter: Pe(
          W.BY_NAME
        )
      },
      delete: {
        method: (n) => {
          switch (e) {
            case L.WORKSPACE:
              return Promise.resolve({});
            case L.STUDY:
              return At()(n);
          }
        }
      }
    }
  }),
  columns: [
    Oe(),
    {
      Header: "Name",
      accessor: "name",
      maxWidth: 400,
      isCropped: !0
    },
    ke(),
    qe(),
    Ke()
  ]
};
function Dt(e, r) {
  switch (e) {
    case y.ACTIVE:
      return r.palette.success.main;
    case y.PENDING:
      return r.palette.warning.main;
    case y.REJECTED:
      return r.palette.error.main;
    case y.DISABLED:
    case y.CANCELLED:
    default:
      return r.palette.grey[400];
  }
}
function Bt(e) {
  return e === y.DISABLED ? "Disabled" : ue(e);
}
const Ft = V((e) => {
  const { status: r } = e, n = it(), { color: i, title: d } = de(() => ({
    color: Dt(r, n),
    title: Bt(r).toUpperCase()
  }), [r, n]);
  return /* @__PURE__ */ t.jsx(
    Q,
    {
      text: /* @__PURE__ */ t.jsx(le, { component: "span", sx: { textTransform: "capitalize" }, children: d.toLowerCase() }),
      placement: "left",
      children: /* @__PURE__ */ t.jsx(
        le,
        {
          "data-status": r,
          sx: {
            backgroundColor: i,
            width: 14,
            height: 14,
            borderRadius: "50%",
            boxShadow: "inset -4px -4px 10px rgba(255,255,255,.4)",
            cursor: "pointer",
            transition: "300ms",
            ":hover": {
              filter: "brightness(90%)"
            }
          }
        }
      )
    }
  );
}), zt = B("div")`
  display: inline-block;
  width: 14px;
  height: 14px;
  padding: 2px;
  position: relative;
  text-align: center;
  border-radius: 50%;
  color: ${({ theme: e }) => e.palette.info.main};
  background-color: ${({ theme: e }) => ye(0.8, e.palette.info.main)};
  transition: 300ms;
  margin-right: 8px;
  cursor: pointer;
  ::after {
    content: 'i';
    display: inline;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    bottom: 1px;
    position: relative;
  }
  :hover {
    background-color: ${({ theme: e }) => ye(0.6, e.palette.info.main)};
  }
  /* svg {
    width: 20px;
    height: 20px;
  } */
`, Yt = ({
  dataSetNames: e
}) => {
  const r = /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    "Role was added automatically as following datasource",
    (e == null ? void 0 : e.length) === 1 ? "" : "s",
    " owner:",
    e.map((n) => /* @__PURE__ */ t.jsx("div", { children: n }, n))
  ] });
  return (e == null ? void 0 : e.length) > 0 ? /* @__PURE__ */ t.jsx(Q, { text: r, children: /* @__PURE__ */ t.jsx(zt, {}) }) : /* @__PURE__ */ t.jsx(t.Fragment, {});
}, Wt = V((e) => {
  const {
    invitation: r,
    showStatus: n = !0,
    changeStatus: i,
    participant: d,
    dataSetNames: l
  } = e, [p, m] = I(!1);
  G(() => {
    m(!1);
  }, [r.status]);
  function j(x) {
    var u, a;
    return (u = x == null ? void 0 : x.actions) != null && u.disable || (a = x == null ? void 0 : x.actions) != null && a.dismiss ? /* @__PURE__ */ t.jsx(
      Ce,
      {
        name: "study-participant-disable-btn",
        size: "small",
        onClick: () => {
          m(!0), i(x, "disable");
        },
        children: /* @__PURE__ */ t.jsx(Q, { text: "Disable participant", color: "primary", width: "auto", children: /* @__PURE__ */ t.jsx(
          w,
          {
            iconName: "deactivate",
            name: "disable",
            sx: { fontSize: 14, color: "text.secondary" }
          }
        ) })
      }
    ) : /* @__PURE__ */ t.jsx(t.Fragment, {});
  }
  function f(x) {
    var u;
    return (u = x == null ? void 0 : x.actions) != null && u.enable ? /* @__PURE__ */ t.jsx(
      Ce,
      {
        name: "study-participant-reload-btn",
        size: "small",
        onClick: () => {
          m(!0), i(x, "enable");
        },
        children: /* @__PURE__ */ t.jsx(Q, { text: "Enable participant", color: "primary", width: "auto", children: /* @__PURE__ */ t.jsx(
          w,
          {
            iconName: "reload",
            name: "reload",
            color: "primary",
            sx: { fontSize: 14, color: "text.secondary" }
          }
        ) })
      }
    ) : /* @__PURE__ */ t.jsx(t.Fragment, {});
  }
  return /* @__PURE__ */ t.jsxs(
    c,
    {
      item: !0,
      xs: 12,
      container: !0,
      spacing: 1,
      fontSize: 14,
      alignItems: "center",
      flexWrap: "nowrap",
      children: [
        /* @__PURE__ */ t.jsxs(c, { container: !0, item: !0, spacing: 1, alignItems: "center", children: [
          /* @__PURE__ */ t.jsx(c, { item: !0, fontWeight: "bold", children: n ? /* @__PURE__ */ t.jsx(Ft, { status: r.status }) : d.fullName }),
          /* @__PURE__ */ t.jsxs(c, { item: !0, display: "flex", color: "textColor.secondary", children: [
            /* @__PURE__ */ t.jsx(le, { component: "span", sx: { minWidth: 120 }, children: r.role.name }),
            /* @__PURE__ */ t.jsx(Yt, { dataSetNames: l }),
            r.dismissNote && /* @__PURE__ */ t.jsx(Je, { tooltipText: r.dismissNote })
          ] })
        ] }),
        /* @__PURE__ */ t.jsx(c, { item: !0, alignSelf: "flex-end", children: p ? /* @__PURE__ */ t.jsx(Me, { size: 16 }) : r.role.id != D.DATA_SET_OWNER && /* @__PURE__ */ t.jsx(t.Fragment, { children: r.status === y.ACTIVE || r.status === y.PENDING ? j(r) : f(r) }) })
      ]
    }
  );
}), Vt = (e) => {
  const { participant: r, showStatus: n = !1, changeStatus: i } = e;
  return /* @__PURE__ */ t.jsxs(
    c,
    {
      container: !0,
      borderBottom: "1px solid #EEEEEE",
      py: 1,
      color: "textColor.secondary",
      spacing: 0.5,
      children: [
        /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, fontWeight: "bold", fontSize: 14, pb: 0.5, children: r.fullName }),
        Object.entries(r.groupedByRole).map(
          ([d, l], p) => {
            const m = l.map((j) => {
              var f;
              return (f = j.dataSource) == null ? void 0 : f.name;
            }).filter((j) => j != null);
            return /* @__PURE__ */ t.jsx(
              Wt,
              {
                invitation: l[0],
                showStatus: n,
                changeStatus: i,
                participant: r,
                dataSetNames: m
              },
              l[0].role.id + p
            );
          }
        )
      ]
    }
  );
}, Gt = V((e) => {
  const { participant: r, onRemove: n, groupingVariant: i } = e, d = Y((l, p) => {
    n == null || n(l, p);
  }, []);
  return /* @__PURE__ */ t.jsx(c, { container: !0, children: /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: i === W.BY_NAME && /* @__PURE__ */ t.jsx(
    Vt,
    {
      changeStatus: d,
      participant: r,
      showStatus: !0
    }
  ) }) });
}), qt = (e) => {
  const { data: r, onRemove: n, processingIds: i, groupingVariant: d } = e, l = Object.values(r.byId);
  return /* @__PURE__ */ t.jsx(c, { container: !0, mt: -1, flexGrow: 1, children: l.map((p) => /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
    Gt,
    {
      participant: p,
      onRemove: n,
      isProcessing: i.includes(p.id),
      groupingVariant: d
    }
  ) }, p.id)) });
};
B.div`
  align-items: center;
  display: flex;
  min-height: 30px;
  color: ${({ theme: e }) => {
  var r;
  return (r = e.palette) == null ? void 0 : r.primary.main;
}};
  font-size: 14px;
  font-weight: bold;
  label {
    margin-right: 10px;
    min-width: 110px;
  }
`;
const Kt = B.div`
  text-align: right;
  & > button:not(:last-of-type) {
    margin-right: 12px;
  }
`;
B.div`
  padding-top: 16px;
`;
const we = {
  participantRoles: [
    D.LEAD_INVESTIGATOR,
    D.CONTRIBUTOR
  ].map((e) => ({
    value: e,
    name: ue($e(e))
  })),
  upsertParticipant: Fe,
  userListGetter: (e) => ({
    primaryKey: "value",
    methods: {
      read: {
        method: () => _t(e),
        formatter: (r) => {
          let n = r.map((i) => ({
            name: i.title,
            value: i.id
          }));
          return n.sort((i, d) => i.name > d.name ? 1 : d.name > i.name ? -1 : 0), n;
        }
      }
    }
  })
}, Jt = V((e) => {
  const { studyId: r, afterCreate: n, onCancel: i } = e, { participantRoles: d, userListGetter: l } = we, { methods: p, primaryKey: m } = l(r), j = me({ methods: p, primaryKey: m, autoLoad: !0 }), [f, x] = I({
    role: d[0].value,
    userId: "",
    message: ""
  }), u = Y(() => {
    const o = {
      roleId: f.role,
      userId: f.userId,
      studyId: r,
      message: f.message
    };
    we.upsertParticipant(r)(o).then((h) => {
      n == null || n(h);
    });
  }, [r, f]), a = Y(
    (o) => (h) => {
      x({
        ...f,
        [o]: h
      });
    },
    [f]
  );
  return /* @__PURE__ */ t.jsx(c, { p: 2, children: /* @__PURE__ */ t.jsx(ot, { elevated: !0, outlined: !0, children: /* @__PURE__ */ t.jsxs(c, { container: !0, spacing: 2, children: [
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(ae, { children: [
      /* @__PURE__ */ t.jsxs("label", { htmlFor: "role", children: [
        "Role ",
        /* @__PURE__ */ t.jsx("span", { className: "required", children: "*" })
      ] }),
      /* @__PURE__ */ t.jsx(
        lt,
        {
          className: "",
          name: "role",
          id: "role",
          options: d,
          value: f.role,
          placeholder: "Select role",
          onChange: a("role"),
          disablePortal: !0,
          fullWidth: !0
        }
      )
    ] }) }),
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 6, children: /* @__PURE__ */ t.jsxs(ae, { children: [
      /* @__PURE__ */ t.jsxs("label", { htmlFor: "user", children: [
        "User ",
        /* @__PURE__ */ t.jsx("span", { className: "required", children: "*" })
      ] }),
      /* @__PURE__ */ t.jsx(
        ee,
        {
          className: "",
          name: "userId",
          id: "user",
          options: Object.values(j.data.byId),
          placeholder: "Select user",
          onChange: (o, h) => {
            a("userId")((h == null ? void 0 : h.value) || "");
          },
          fullWidth: !0,
          getOptionLabel: (o) => {
            var h;
            return (o == null ? void 0 : o.name) || ((h = j.data.byId[o]) == null ? void 0 : h.name) || "";
          },
          value: f.userId,
          isOptionEqualToValue: (o, h) => (o == null ? void 0 : o.value) === h,
          getOptionKey: (o) => o.value,
          loading: j.status === gt.IN_PROGRESS
        }
      )
    ] }) }),
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(ae, { children: [
      /* @__PURE__ */ t.jsx("label", { htmlFor: "message", children: "Message" }),
      /* @__PURE__ */ t.jsx(
        ct,
        {
          id: "message",
          name: "message",
          value: f.message,
          onChange: a("message"),
          maxRows: 10,
          minRows: 5,
          disableHorizontalResize: !0
        }
      )
    ] }) }),
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Kt, { children: [
      /* @__PURE__ */ t.jsx(
        O,
        {
          variant: "outlined",
          onClick: i,
          startIcon: /* @__PURE__ */ t.jsx(w, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ t.jsx(
        O,
        {
          onClick: u,
          disabled: !f.userId || !f.role,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ t.jsx(w, { iconName: "submit" }),
          name: "save",
          children: "Add"
        }
      )
    ] }) })
  ] }) }) });
}), Ht = (e) => {
  var F;
  const {
    name: r,
    // groupingVariants,
    addButtonText: n,
    title: i,
    redirectButtonText: d,
    modal: l,
    apiMethods: p,
    parentId: m,
    groupingVariant: j,
    setParticipantsGroupingVariant: f,
    viewMode: x
  } = e, u = De(), a = Be((T) => T.invitations.count), [o, h] = I(null), { openModal: S, closeModal: _ } = ie(Ue), P = me({
    methods: p.methods,
    primaryKey: p.primaryKey
  });
  G(() => {
    P.getEntityList();
  }, [a]);
  const q = Y(() => {
    S(
      () => /* @__PURE__ */ t.jsx(
        Jt,
        {
          afterCreate: K,
          onCancel: M,
          studyId: m
        }
      ),
      o ? l.header.edit : l.header.new,
      {
        onClose: M,
        width: "700px",
        closeOnClickOutside: !0
      }
    );
  }, [j]), M = Y(() => {
    h(null), _();
  }, []), K = async () => {
    P.getEntityList(), M(), u(Se(L.STUDY, m));
  }, J = Y(
    async (T, b) => {
      try {
        b === "disable" ? T.status === y.ACTIVE ? await Pt(T.id) : T.status === y.PENDING && await wt(T.id) : T.status === y.DISABLED ? await Nt(T.id) : (T.status === y.REJECTED || T.status === y.CANCELLED) && await Fe(m)({
          roleId: T.role.id,
          studyId: m,
          userId: T.subject.id,
          message: ""
        }), u(Se(L.STUDY, m)), await P.getEntityList();
      } catch (C) {
        console.error(C);
      }
    },
    [j]
  );
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsx(
    He,
    {
      addButtonText: n,
      onAddClick: q,
      viewMode: x,
      status: P.status,
      isEmpty: ((F = P.data.ids) == null ? void 0 : F.length) === 0,
      actions: P.actions,
      listName: "participants",
      emptyTableText: "No participants",
      children: /* @__PURE__ */ t.jsx(
        qt,
        {
          groupingVariant: j,
          data: P.data,
          processingIds: P.processingIds,
          onRemove: J
        }
      )
    }
  ) });
}, Xt = (e) => {
  const { path: r, config: n, viewMode: i } = e, { typeContainer: d, parentId: l } = n, {
    name: p,
    addButtonText: m,
    title: j,
    redirectButtonText: f,
    modal: x,
    getApiMethods: u
    // groupingVariants,
  } = Ut, [a, o] = I(W.BY_NAME), h = de(() => u(d, l), [l, d]);
  return /* @__PURE__ */ t.jsx(
    Ht,
    {
      addButtonText: m,
      title: j,
      redirectButtonText: f,
      name: p,
      apiMethods: h,
      modal: x,
      parentId: l,
      groupingVariant: a,
      setParticipantsGroupingVariant: o,
      viewMode: i
    }
  );
}, Zt = B(c)`
  padding: 4px 4px 4px 8px;
  border-bottom: 1px solid
    ${({ theme: e }) => e.palette.borderColor.light};
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme: e }) => e.palette.backgroundColor.main};
  }
  svg {
    font-size: 16px;
  }
`, Ye = (e, r) => (e.object.title || "").localeCompare(
  r.object.title || "",
  void 0,
  { sensitivity: "base" }
) || e.object.id.localeCompare(r.object.id), Ae = (e) => [...e].sort(Ye), Qt = (e) => {
  const { tenantId: r, onChange: n, users: i } = e, [d, l] = I([]), [p, m] = I(
    []
  ), j = U.useMemo(() => {
    const u = p == null ? void 0 : p.map((o) => o.object.id);
    return i.filter((o) => {
      var h;
      return !u.includes(((h = o == null ? void 0 : o.object) == null ? void 0 : h.id) || o.id);
    }).map(
      (o) => o.object ? o : {
        object: { ...o, title: oe(o) }
      }
    ).sort(Ye);
  }, [i, p]), f = (u) => {
    const a = Ae(u);
    m(a), n(x(a));
  }, x = U.useCallback(
    (u) => {
      const a = u.filter(
        (h) => !d.map((S) => S.object.id).includes(h.object.id)
      ), o = d.filter(
        (h) => !u.map((S) => S.object.id).includes(h.object.id)
      );
      return { added: a, deleted: o };
    },
    [d]
  );
  return G(() => {
    Ot(r).then(
      (u) => {
        const a = Ae(u);
        l(a), m(a);
      }
    );
  }, []), /* @__PURE__ */ t.jsxs(c, { container: !0, p: 2, spacing: 2, children: [
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx($, { name: "existUsers", textLabel: "Added users", children: /* @__PURE__ */ t.jsx(c, { container: !0, mt: 2, children: p.length > 0 ? p.map((u) => /* @__PURE__ */ t.jsxs(
      Zt,
      {
        item: !0,
        xs: 12,
        container: !0,
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ t.jsx(c, { item: !0, children: u.object.title }),
          /* @__PURE__ */ t.jsx(c, { item: !0, children: /* @__PURE__ */ t.jsx(
            O,
            {
              size: "small",
              sx: { minWidth: 20 },
              color: "error",
              onClick: () => f(
                p.filter(
                  (a) => a.object.id !== u.object.id
                )
              ),
              children: /* @__PURE__ */ t.jsx(w, { iconName: "deactivate" })
            }
          ) })
        ]
      },
      u.object.id
    )) : /* @__PURE__ */ t.jsx("div", { children: "-" }) }) }) }),
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx($, { name: "participantsList", textLabel: "Add new users", children: /* @__PURE__ */ t.jsx(
      ee,
      {
        className: "",
        name: "participantsList",
        id: "participantsList",
        options: j,
        value: p,
        placeholder: "Select users",
        multiple: !0,
        onChange: (u, a) => {
          f(a);
        },
        fullWidth: !0,
        getOptionLabel: (u) => u.object.title,
        isOptionEqualToValue: (u, a) => (u == null ? void 0 : u.object.id) === (a == null ? void 0 : a.object.id),
        renderTags: () => "",
        disableClearable: !0
      }
    ) }) }) })
  ] });
}, er = B(c)`
  padding: 4px 4px 4px 8px;
  border-bottom: 1px solid
    ${({ theme: e }) => e.palette.borderColor.light};
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme: e }) => e.palette.backgroundColor.main};
  }
  svg {
    font-size: 16px;
  }
`, tr = (e) => {
  const { datasourceId: r, onChange: n, users: i, methodList: d } = e, [l, p] = I([]), [m, j] = I([]), f = U.useMemo(() => {
    const a = m == null ? void 0 : m.map((h) => h.id);
    return i.filter((h) => !a.includes(h.id)).map((h) => ({ ...h, title: oe(h) }));
  }, [i, m]), x = (a) => {
    j(a), n(u(a));
  }, u = U.useCallback(
    (a) => {
      const o = a.filter(
        (S) => !l.map((_) => _.id).includes(S.id)
      ), h = l.filter(
        (S) => !a.map((_) => _.id).includes(S.id)
      );
      return { added: o, deleted: h };
    },
    [l]
  );
  return G(() => {
    d(r).then((a) => {
      p(a), j(a);
    });
  }, []), /* @__PURE__ */ t.jsxs(c, { container: !0, p: 2, spacing: 2, children: [
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx($, { name: "existUsers", textLabel: "Added data owners", children: /* @__PURE__ */ t.jsx(c, { container: !0, mt: 2, children: m.length > 0 ? m.map((a) => /* @__PURE__ */ t.jsxs(
      er,
      {
        item: !0,
        xs: 12,
        container: !0,
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ t.jsx(c, { item: !0, children: oe(a) }),
          /* @__PURE__ */ t.jsx(c, { item: !0, children: /* @__PURE__ */ t.jsx(
            O,
            {
              size: "small",
              sx: { minWidth: 20 },
              color: "error",
              onClick: () => x(
                m.filter((o) => o.id !== a.id)
              ),
              children: /* @__PURE__ */ t.jsx(w, { iconName: "deactivate" })
            }
          ) })
        ]
      },
      a.id
    )) : /* @__PURE__ */ t.jsx("div", { children: "-" }) }) }) }),
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx($, { name: "participantsList", textLabel: "Add new data owner", children: /* @__PURE__ */ t.jsx(
      ee,
      {
        className: "",
        name: "participantsList",
        id: "participantsList",
        options: f,
        value: m,
        placeholder: "Select participants",
        multiple: !0,
        onChange: (a, o) => {
          x(o);
        },
        fullWidth: !0,
        getOptionLabel: (a) => a.title,
        isOptionEqualToValue: (a, o) => (a == null ? void 0 : a.id) === (o == null ? void 0 : o.id),
        renderTags: () => "",
        disableClearable: !0
      }
    ) }) }) })
  ] });
}, rr = {
  userListGetter: () => ({
    primaryKey: "value",
    methods: {
      read: {
        method: () => St(),
        formatter: (e) => e.map((r) => ({
          name: `${r.firstName} ${r.lastName}`,
          email: r.email,
          value: r.id
        }))
      }
    }
  })
}, _e = B(c)`
  padding: 4px 4px 4px 8px;
  border-bottom: 1px solid
    ${({ theme: e }) => e.palette.borderColor.light};
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme: e }) => e.palette.backgroundColor.main};
  }
  svg {
    font-size: 16px;
  }
`, sr = V((e) => {
  const { entity: r, entityType: n, onClose: i } = e, { userListGetter: d } = rr, { methods: l, primaryKey: p } = d(), m = me({ methods: l, primaryKey: p, autoLoad: !0 }), [j, f] = I([]), [x, u] = I([]), [a, o] = I(""), [h, S] = I(""), { enqueueSnackbar: _ } = dt(), P = () => `mailto:${x.map((H) => H.email).concat(j).join(",")}?subject=${encodeURIComponent(
    `Prometheus: ${n} Collaboration invitation: ${r.name}`
  )}&body=${encodeURIComponent(
    `You are invited to view the ${n} "${r.name}":

${window.location.href}`
  )}`, q = async () => {
    window.location.href = P(), _({
      message: "Cohort has been shared",
      variant: "success"
    }), i();
  }, M = (b) => {
    b && !x.includes(b) && u([...x, b]);
  }, K = (b) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(b), J = () => {
    a && (K(a) ? j.includes(a) ? S("This email is already added.") : (f([...j, a]), o(""), S("")) : S("Please enter a valid email address."));
  }, F = (b) => {
    f(j.filter((C) => C !== b));
  }, T = (b) => {
    u(
      x.filter((C) => C.email !== b.email)
    );
  };
  return /* @__PURE__ */ t.jsx(c, { container: !0, p: 2, children: /* @__PURE__ */ t.jsx(ut, { children: /* @__PURE__ */ t.jsxs(c, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx($, { name: "targetUsers", textLabel: "Add Prometheus User:", children: /* @__PURE__ */ t.jsx(
      ee,
      {
        className: "",
        name: "userId",
        id: "targetUsers",
        options: Object.values(m.data.byId),
        placeholder: "Select user",
        onChange: (b, C) => {
          M(C);
        },
        fullWidth: !0,
        getOptionLabel: (b) => {
          var C;
          return (b == null ? void 0 : b.name) || ((C = m.data.byId[b]) == null ? void 0 : C.name) || "";
        },
        isOptionEqualToValue: (b, C) => (b == null ? void 0 : b.value) === C
      }
    ) }) }) }),
    /* @__PURE__ */ t.jsxs(c, { item: !0, xs: 12, children: [
      /* @__PURE__ */ t.jsx($, { name: "targetEmails", textLabel: "Add External E-mail:", children: /* @__PURE__ */ t.jsx(
        mt,
        {
          type: "email",
          value: a,
          onChange: (b) => {
            o(b.target.value), S("");
          },
          placeholder: "Add email",
          fullWidth: !0
        }
      ) }),
      h && /* @__PURE__ */ t.jsx("p", { className: "error", children: h })
    ] }),
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      O,
      {
        onClick: J,
        variant: "contained",
        color: "success",
        startIcon: /* @__PURE__ */ t.jsx(w, { iconName: "add" }),
        name: "addExternalEmail",
        children: "Add"
      }
    ) }),
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      $,
      {
        name: "targetPrometheusUsers",
        textLabel: "Selected Prometheus users:",
        children: /* @__PURE__ */ t.jsx(c, { container: !0, mt: 2, children: x.length > 0 ? x.map((b, C) => /* @__PURE__ */ t.jsxs(
          _e,
          {
            item: !0,
            xs: 12,
            container: !0,
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ t.jsx(c, { item: !0, children: b.email }),
              /* @__PURE__ */ t.jsx(c, { item: !0, children: /* @__PURE__ */ t.jsx(
                O,
                {
                  size: "small",
                  sx: { minWidth: 20 },
                  color: "error",
                  onClick: () => T(b),
                  children: /* @__PURE__ */ t.jsx(w, { iconName: "deactivate" })
                }
              ) })
            ]
          },
          C
        )) : /* @__PURE__ */ t.jsx("div", { children: "-" }) })
      }
    ) }),
    /* @__PURE__ */ t.jsx(pt, {}),
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      $,
      {
        name: "targetExternalEmails",
        textLabel: "External users:",
        children: /* @__PURE__ */ t.jsx(c, { container: !0, mt: 2, children: j.length > 0 ? j.map((b, C) => /* @__PURE__ */ t.jsxs(
          _e,
          {
            item: !0,
            xs: 12,
            container: !0,
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ t.jsx(c, { item: !0, children: b }),
              /* @__PURE__ */ t.jsx(c, { item: !0, children: /* @__PURE__ */ t.jsx(
                O,
                {
                  size: "small",
                  sx: { minWidth: 20 },
                  color: "error",
                  onClick: () => F(b),
                  children: /* @__PURE__ */ t.jsx(w, { iconName: "deactivate" })
                }
              ) })
            ]
          },
          C
        )) : /* @__PURE__ */ t.jsx("div", { children: "-" }) })
      }
    ) }),
    /* @__PURE__ */ t.jsx(c, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Xe, { children: [
      /* @__PURE__ */ t.jsx(
        O,
        {
          variant: "outlined",
          onClick: i,
          startIcon: /* @__PURE__ */ t.jsx(w, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ t.jsx(
        O,
        {
          onClick: q,
          disabled: j.length <= 0 && x.length <= 0,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ t.jsx(w, { iconName: "submit" }),
          name: "share",
          children: "Share"
        }
      )
    ] }) })
  ] }) }) });
}), nr = V((e) => {
  const { name: r, path: n, config: i, children: d, viewMode: l } = e, {
    parentId: p,
    onChange: m,
    onCancel: j,
    users: f,
    methodList: x,
    onClose: u,
    entity: a,
    entityType: o
  } = i;
  return /* @__PURE__ */ t.jsxs(U.Fragment, { children: [
    r === "widget-info" && /* @__PURE__ */ t.jsx(Xt, { path: n, config: i, viewMode: l }),
    r === "participant-list-current-tenant" && /* @__PURE__ */ t.jsx(
      Qt,
      {
        tenantId: p,
        users: f,
        onChange: m
      }
    ),
    r === "users-owner-list" && /* @__PURE__ */ t.jsx(
      tr,
      {
        datasourceId: p,
        users: f,
        methodList: x,
        onChange: m,
        onClose: j,
        children: d
      }
    ),
    r === "share-entity" && /* @__PURE__ */ t.jsx(
      sr,
      {
        entity: a,
        entityType: o,
        onChange: m,
        onClose: u
      }
    )
  ] });
}), ar = {
  rowId: "id",
  loadingMessage: "Loading data cources...",
  addButtonTitle: "Add data source",
  tableTitle: "Users",
  importButtonTitle: "Import",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createCrudMethod: () => at(
    null,
    null,
    yt,
    () => Promise.resolve()
  ),
  createFiltersPanel: () => nt(null, null, vt),
  createSortingMethod(e) {
    return st(e, {
      getSorting: kt
    });
  },
  cols: [
    {
      header: "",
      accessorFn: (e) => {
        var r, n;
        return `${((r = e == null ? void 0 : e.firstName) == null ? void 0 : r[0]) || ""}${((n = e == null ? void 0 : e.lastName) == null ? void 0 : n[0]) || ""}`;
      },
      id: "logo",
      enableSorting: !1,
      enableHiding: !1,
      cell: (e) => /* @__PURE__ */ t.jsx(
        xt,
        {
          sx: (r) => ({
            fontSize: 12,
            width: 30,
            height: 30,
            // fontWeight: 'bold',
            backgroundColor: r.palette.secondary.main,
            color: r.palette.primary.main
          }),
          children: e.value
        }
      )
    },
    Oe(),
    {
      header: "Name",
      accessorFn: (e) => `${(e == null ? void 0 : e.firstName) || ""} ${(e == null ? void 0 : e.middleName) || ""} ${e.lastName || ""}` || "-",
      id: "firstName"
    },
    { header: "Email", accessorKey: "email", id: "email" },
    ke(),
    {
      header: "Updated",
      accessorKey: "modified.timestamp",
      id: "modified.timestamp",
      cell: Ze,
      minSize: 140,
      maxSize: 140
    }
  ]
}, ir = () => {
  const e = U.useContext(
    pe
  );
  return /* @__PURE__ */ t.jsx(
    Qe,
    {
      moduleConfig: e,
      listConfig: ar
    }
  );
}, or = {
  createCrudEntity: () => ({
    getMethod: (e) => Tt(e),
    deleteMethod: (e) => Promise.resolve(),
    upsertMethod: (e) => Promise.resolve()
  }),
  entityBreadcrumbs: (e, r, n) => {
    var i;
    return [
      {
        name: "Users",
        path: `/${e}`
      },
      {
        name: (i = n == null ? void 0 : n.base) == null ? void 0 : i.title,
        path: `/${e}/${r}`
      }
    ];
  }
};
[
  D.LEAD_INVESTIGATOR,
  D.CONTRIBUTOR
].map((e) => ({
  value: e,
  name: ue($e(e))
}));
const lr = () => {
  const { id: e } = jt(), r = De(), { openModal: n, closeModal: i } = ie(Ue);
  Be(
    (h) => h.user.data
  );
  const { rootSettings: d, path: l, title: p, config: m, subModules: j } = ie(
    pe
  ), { createCrudEntity: f, entityBreadcrumbs: x } = or, u = de(() => f(), []), { status: a, entity: o } = ht(
    {
      get: u.getMethod,
      delete: u.deleteMethod,
      update: u.upsertMethod
    },
    e
  );
  return G(() => {
    o && r(ft(x(l, e, o)));
  }, [l, o]), /* @__PURE__ */ t.jsx(c, { container: !0 });
}, pe = Ge(null), cr = (e) => {
  const { path: r, title: n, name: i, storage: d, rootSettings: l, initStorage: p } = e, [m, j] = I(l), [f, x] = I(!0);
  return G(() => {
    l || j({
      rootPath: r,
      rootTitle: n
    }), x(!1);
  }, []), f ? /* @__PURE__ */ t.jsx(et, { children: /* @__PURE__ */ t.jsx(Me, { size: 32 }) }) : /* @__PURE__ */ t.jsx(pe.Provider, { value: { ...e, rootSettings: m }, children: /* @__PURE__ */ t.jsxs(bt, { children: [
    /* @__PURE__ */ t.jsx(Te, { path: ":id/*", element: /* @__PURE__ */ t.jsx(lr, {}) }),
    /* @__PURE__ */ t.jsx(Te, { index: !0, element: /* @__PURE__ */ t.jsx(ir, {}) })
  ] }) });
}, Cr = (e) => {
  const { type: r } = e;
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    !r && /* @__PURE__ */ t.jsx(cr, { ...e }),
    r === "component" && /* @__PURE__ */ t.jsx(nr, { ...e })
  ] });
};
export {
  Cr as Users
};
//# sourceMappingURL=users.js.map
